var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticClass:"crm-layout"},[_c('crm-navigation-bar'),_c('v-main',{staticClass:"pt-10 pb-12 mb-12"},[_c('v-container',[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }